import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { Image } from '../Image';
import { SmartLink } from '../SmartLink';
import { getMaxWidthsBySize } from '../../domain/utils/getMaxWidthsBySize';
import { theme } from '../../domain/theme';

export const RelatedPods = ({ galleries }) => {
  const styles = {
    wrapper: css`
      display: flex;
      flex-wrap: nowrap;
      justify-content: flex-start;
      align-items: flex-start;
      align-content: flex-start;
      flex-direction: column;
      ${theme.mq.tablet} {
        flex-direction: row;
      }
      margin: ${theme.spacing('xl2')} 0;
    `,
    itemWrapper: css`
      width: 100%;
      padding: 0;
      padding-bottom: ${theme.spacing('xs')};
      ${theme.mq.tablet} {
        width: 50%;
      }
    `,
    imageContainer: css`
      position: relative;
      picture::after {
        background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);
        bottom: 0;
        content: '';
        height: 25%;
        opacity: 1;
        position: absolute;
        width: 100%;
        z-index: ${theme.zIndex('modal')};
      }
    `,

    titleContainer: css`
      position: absolute;
      bottom: ${theme.spacing('xs')};
      left: ${theme.spacing('xs')};
      max-width: 90%;
      ${theme.font.family('boldWeb')};
      font-size: ${theme.font.size('xl')};
      letter-spacing: ${theme.letterSpacing('xs2')};
      line-height: ${theme.line.height('s')};
      color: #fff;
      z-index: ${theme.zIndex('cookies')};
    `
  };

  return (
    <div css={styles.wrapper}>
      {galleries.map(relatedGallery => {
        const imageUrl =
          relatedGallery.entity?.promoImage?.[0]?.entity?.mediaImage?.url;
        if (!imageUrl) {
          return null;
        }
        const imageEntity = {
          mediaImage: {
            url: imageUrl,
            ...relatedGallery.entity.promoImage[0].entity.mediaImage
          }
        };
        return (
          <div css={styles.itemWrapper} key={relatedGallery.entity?.id}>
            <SmartLink
              title={relatedGallery.entity.title}
              to={relatedGallery.entity.url.path}
            >
              <div css={styles.imageContainer}>
                <Image
                  entity={imageEntity}
                  aspect="16x9"
                  maxWidths={getMaxWidthsBySize('small')}
                  alt={imageEntity.alt}
                />
                <div css={styles.titleContainer}>
                  {relatedGallery.entity.title}
                </div>
              </div>
            </SmartLink>
          </div>
        );
      })}
    </div>
  );
};

RelatedPods.propTypes = {
  galleries: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired
};
